import React, { useContext, useEffect, useState } from "react";
import styles from "./Templates.module.css";
import { Button, Header, Modal, Navbar } from "../../components";
import { Bars, Star, StarFull, Wait } from "../../components/Icons/Icons";
import { ResumeContext } from "../../contexts/resumeContext";
import { useNavigate, useSearchParams } from "react-router-dom";
import { collection, addDoc } from "firebase/firestore";
import { db } from "../../firebase";
import { UserContext } from "../../contexts/userContext";
import { templates } from "../../utils/constants";

function Templates() {
  const navigate = useNavigate();
  const [searchParams, setSearchParams] = useSearchParams();
  const { setActiveDesign, setResumeInfo } = useContext(ResumeContext);
  const { user } = useContext(UserContext);
  const [showModal, toggleModal] = useState(false);

  const activeTemplate = searchParams.get("template");

  useEffect(() => {
    if (activeTemplate) {
      handleTemplateSelect(activeTemplate);
    }
  }, [activeTemplate]);

  const handleTemplateSelect = async (templateName) => {
    toggleModal(true);
    setActiveDesign(templateName);
    setResumeInfo({});

    const docDataRef = await addDoc(
      collection(db, "documentData"),
      user ? { user: user?.uid } : {}
    );

    const resumeObj = {
      docDataRef: docDataRef.id,
      design: templateName,
      name: `Resume_${new Date().getTime()}`,
      createdAt: new Date(),
    };

    if (user) {
      resumeObj["user"] = user?.uid;
    }

    const docRef = await addDoc(collection(db, "documents"), resumeObj);
    toggleModal(false);
    navigate(`/resume/${docRef.id}/edit/?section=personal`);
  };

  return (
    <>
      <Navbar />
      <div className={styles.templates}>
        <h1 className={styles.header}>
          Select from recruiter proofed templates
        </h1>
        <p className={styles.subheader}>
          Quality over Quantity. Hand-picked resume designs that are
          battle-tested
        </p>
        <div className={styles.row}>
          {templates.map((template) => (
            <div className={styles.col} key={template.name}>
              <div
                className={styles.image}
                onClick={() => handleTemplateSelect(template.name)}
              >
                <img src={template.img} className="image" />
                <Button content="select this template" className={styles.btn} />
                {/* <button className={styles.btn}>Select Template</button> */}
              </div>
              <p className={styles.name}>{template.name}</p>
              <p className={styles.desc}>{template.desc}</p>
              <p className={styles.rating}>
                ATS Friendly:{" "}
                {[...Array(template?.AtsRating)].map((rate, ix) => (
                  <StarFull key={ix} />
                ))}{" "}
                {[...Array(5 - template?.AtsRating)].map((rate, ix) => (
                  <Star key={ix} />
                ))}
              </p>
              <p className={styles.rating}>
                Print Friendly:{" "}
                {[...Array(template?.printRating)].map((rate, ix) => (
                  <StarFull key={ix} />
                ))}{" "}
                {[...Array(5 - template?.printRating)].map((rate, ix) => (
                  <Star key={ix} />
                ))}
              </p>
            </div>
          ))}
        </div>
      </div>
      <Modal active={showModal}>
        <div className={styles.modal}>
          <div className={styles.svg}>
            <Bars />
          </div>
          <p className={styles.modalText}>
            Hold on! <br />
            Preparing your resume...
          </p>
        </div>
      </Modal>
    </>
  );
}

export default Templates;
